module.exports = __webpack_public_path__ + "img/icon.c65e2c3e.svg";